import type { ToolCallGenericMessage } from '@terra/shared-dto-chat-types';

export const isLatestToolCallOfName = ({
  toolCallId,
  toolName,
  toolResultsById,
}: {
  toolCallId?: string;
  toolName?: string;
  toolResultsById?: Record<string, ToolCallGenericMessage>;
}): boolean => {
  if (!toolCallId || !toolName || !toolResultsById) {
    return true;
  }

  const latestToolCallId = Object.entries(toolResultsById)
    .filter(([, toolCall]) => toolCall.toolName === toolName)
    .map(([id]) => id)
    .at(-1);

  return latestToolCallId === undefined || latestToolCallId === toolCallId;
};
